export default "__VITE_ASSET__B8qLxRFg__"